import { createTheme } from "@mui/material/styles";

// Default (Light) Theme
const lightTheme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#fff",
      level1: "#F4F4F4",
      level2: "#EAEAEA",
      level3: "#D3D3D3",
    },
    primary: {
      main: "#00a3e0",
      secondary: "#eef9ff",
      contrast: "#02536d",
      background: "#f5fbff",
      contrastText: "#fff",
    },
    teal: {
      main: "#009ca6",
      light: "#eefeff",
      dark: "#007d85",
    },
    text: { main: "#3a3a3a", secondary: "#595959" },
    error: { main: "#f44336" },
    blue: { main: "#00a3e0" },
    green: {
      main: "#8cb71f",
    },
    grey: {
      light: "#f0f0f0",
      main: "#545759",
      dark: "#a9adb0",
    },
    pink: {
      main: "#ce0f69",
    },
    white: { main: "#FFF" },
    orange: { main: "#f7810c" },
    purple: { main: "#9355db" },
  },
});

// Dark Theme
const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#222222",
      level1: "#333333",
      level2: "#474747",
      level3: "#686868",
    },
    primary: {
      main: "#00a3e0",
      secondary: "#02536d",
      contrast: "#bbe7ff",
      background: "#142930",
      contrastText: "#fff",
    },
    teal: {
      main: "#009ca6",
      light: "#eefeff",
      dark: "#007d85",
    },
    text: { main: "#fff", secondary: "#EEEEEE" },
    error: { main: "#f44336" },
    blue: { main: "#00a3e0" },
    green: {
      main: "#8cb71f",
    },
    grey: {
      light: "#f0f0f0",
      main: "#c9cbcc",
      dark: "#a9adb0",
    },
    pink: {
      main: "#ce0f69",
    },
    white: { main: "#fff" },
    orange: { main: "#f7810c" },
    purple: { main: "#9355db" },
  },
});

export { lightTheme, darkTheme };
